import ClausesConsentement from '@/shared/components/ClausesConsentement';

/**
 * Les consentements, sur la page de fin de chantier. Un bloc, plus une étape.
 *
 * ⚠️ IL A ÉTÉ UNE ÉTAPE, ET SA DISPARITION EST VOULUE. Le lot C les avait sortis de
 * l'écran de signature unique le 27/08 pour leur donner l'étape 6 : le client donnait
 * ses accords APRÈS avoir signé la fin de ses travaux, ce qui était le bon défaut à
 * fermer. David a tranché autrement le 30/08 — mandat, consentements et réception sur
 * UNE page, sous UNE signature — et l'ordre du client est respecté ici : il lit ses
 * autorisations AVANT de signer, puisque la signature est en bas de la même page.
 *
 * LE TEXTE VIENT DU SERVEUR, ET C'EST LE MÊME QUE DANS LE CRM. Le bouton
 * « Cocher les 4 autorisations » a disparu avec les clauses écrites en dur, et ce n'est
 * pas une perte de confort : il cochait quatre cases d'un geste sur un texte que
 * personne n'avait lu, ce qui est précisément le défaut mesuré le 24/08 sur les CGV —
 * 70 mandats sur 70 déclaraient un accord jamais demandé.
 *
 * ⚠️ UNE CASE « TOUT COCHER » EST REVENUE LE 02/09, ET ELLE N'EST PAS CE BOUTON-LÀ.
 * Elle vit dans `ClausesConsentement`, en TÊTE de liste depuis le 07/09 — Boubacar la
 * voulait « au début et pas en dernier » —, jamais cochée d'avance, et chaque case reste
 * décochable individuellement sous elle. Le raisonnement complet, revirement compris, est
 * écrit là-bas, à côté du code qui l'applique.
 *
 * ⚠️ LE CONSENTEMENT ENERGRID A QUITTÉ CET ÉCRAN LE 10/09/2026, ET IL NE REVIENT PAS
 * PAR INADVERTANCE.
 *
 * Ce bloc montait `ClausePdl` — l'accès aux données du compteur, la carte portant
 * « version v1 » en haut à droite — dans les annexes de `ClausesConsentement`, où la case
 * maîtresse la cochait aussi (demande du 02/09). Demande de Boubacar le 10/09, mot pour
 * mot : « Au moment des signatures de mandat, il n'est pas nécessaire de garder la case à
 * cocher pour le consentement d'Energrid […] elle doit sauter de l'écran de consentement
 * avant signature des mandats ». Le composant a donc été supprimé, pas seulement démonté.
 *
 * TROIS CONSÉQUENCES QUI NE SE DEVINENT PAS EN LISANT CE FICHIER :
 *
 * 1. Le parcours envoie l'accord SEUL. `POST /pdl/consentements` part toujours à la fin
 *    du parcours, avec `consentement_accepte: true` écrit par le code et non par une case
 *    — voir `InstallateurPage.handleSign`, qui porte le pourquoi.
 * 2. L'exigence côté API est GARDÉE EXPRÈS. Ne pas la « réparer » en la rendant
 *    facultative sous prétexte que plus personne ne coche : c'est elle qui interdit à un
 *    appel sans interface de déclarer un consentement chez Energrid au nom d'une personne
 *    réelle. Le raisonnement est dans `backend/app/modules/pdl/routes.py`.
 * 3. Le signal `onDisponible` et l'état `pdlAffiche` ont disparu AVEC l'enfant. Les
 *    garder aurait laissé un état fantôme : la case maîtresse aurait piloté un
 *    consentement que plus aucun écran ne montre.
 *
 * Le raisonnement complet, et la mesure de ce qui porte la preuve après le retrait :
 * `docs/decisions/2026-09-10-retrait-de-la-clause-energrid.md`.
 *
 * Présentationnel : il ne sait ni enregistrer ni naviguer. L'état qu'il tient ne dit que
 * ce qui est à l'écran.
 */
export default function BlocConsentements({ consents, setConsents }) {
  return (
    <div className="space-y-4" data-testid="bloc-consentements">
      <div>
        <p className="text-[12px] font-medium text-neutral-700">Consentements</p>
        <p className="text-[11px] text-neutral-500">
          Les autorisations nécessaires à l&apos;exploitation du mandat.
        </p>
      </div>

      <div className="rounded-lg border border-neutral-200 bg-white p-4">
        <ClausesConsentement consents={consents} setConsents={setConsents} compact />
      </div>
    </div>
  );
}
